<template>
    <v-container grid-list-md class="form-user-payment">
        <v-layout row wrap>
            <v-flex md8>
                <v-form>
                    <v-layout align-center row class="pa-0">
                        <v-flex xs12>

                            <v-card>
                                <v-card-title>
                                    Lịch Sử Biến Động:
                                    <v-spacer></v-spacer>

                                    <div class="float-right div-icon-action">
                                        <v-icon @click="print" >mdi-printer</v-icon>
                                    </div>
                                    <div class="float-right div-icon-action ml-0">
                                        <export-excel  :data   = "desserts">
                                            <v-icon>mdi-file-export</v-icon>
                                        </export-excel>
                                    </div>
                                </v-card-title>
                                <div id="fb-post-activity-log">
                                    <v-data-table
                                            :headers="headers"
                                            :items="desserts"
                                            :options.sync="options"
                                            :server-items-length="totalDesserts"
                                            :loading="loading"
                                            class="elevation-1"
                                    >
                                    <!-- define('MONEY_IN', 1);
define('MONEY_OUT', 2);
define('MONEY_PAY', 3);
define('MONEY_CASHBACK', 4); -->
                                        <template v-slot:item.coin="{ item }">
                                            <v-chip v-if="item.type_id == 1 || item.type_id == 9" color="teal" dark>
                                                {{ item.money | currency }}
                                            </v-chip>
                                            <v-chip v-if="item.type_id==4" color="primary" dark>
                                                {{ item.money | currency }}
                                            </v-chip>
                                            <v-chip v-if="item.type_id==2 || item.type_id == 8" color="dark" dark>
                                                {{ item.money | currency }}
                                            </v-chip>
                                            <v-chip v-if="item.type_id==3" color="red" dark>
                                                {{ item.money | currency }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item.job_type="{ item }">
                                            <p v-if="item.job_type">
                                                {{ item.note }} - {{ item.job_id }}
                                            </p>
                                            <p v-if="item.type_id == 1 && item.status == 2">
                                                Bạn đã nạp tiền thành công!
                                            </p>
                                            <p v-if="item.type_id == 1 && item.status == 1">
                                                Chờ duyệt tiền
                                            </p>
                                            <p v-if="item.status == 99">
                                                Đã bị huỷ
                                            </p>
                                        </template>
                                        <template v-slot:item.current_customer_coin="{ item }">
                                            <v-chip v-if="item.current_customer_coin && item.type_id==1 " color="orange" dark>
                                                {{ item.before_customer_coin | currency }} + {{ item.coin | currency  }} = {{ item.current_customer_coin | currency  }}
                                            </v-chip>
                                            <v-chip v-if="item.current_customer_coin && item.type_id==4" color="orange" dark>
                                                {{ item.before_customer_coin | currency  }} + {{ item.coin | currency  }} = {{ item.current_customer_coin | currency  }}
                                            </v-chip>
                                            <v-chip v-if="item.current_customer_coin && item.type_id==2" color="orange" dark>
                                                {{ item.before_customer_coin | currency  }} - {{ item.coin | currency }} = {{ item.current_customer_coin | currency  }}
                                            </v-chip>
                                            <v-chip v-if="item.current_customer_coin && item.type_id==3" color="orange" dark>
                                                {{ item.before_customer_coin | currency  }} - {{ item.coin | currency }} = {{ item.current_customer_coin | currency  }}
                                            </v-chip>
                                            <v-chip v-if="item.current_customer_coin && item.type_id==8" color="orange" dark>
                                                {{ item.before_customer_coin | currency  }} + {{ item.coin | currency }} = {{ item.current_customer_coin | currency  }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item.current_customer_coin="{ item }">
                                            <v-chip v-if="item.current_customer_coin && item.type_id==1 " color="orange" dark>
                                                {{ item.before_customer_coin | currency }} + {{ item.coin | currency  }} = {{ item.current_customer_coin | currency  }}
                                            </v-chip>
                                            <v-chip v-if="item.current_customer_coin && item.type_id==4" color="orange" dark>
                                                {{ item.before_customer_coin | currency  }} + {{ item.coin | currency  }} = {{ item.current_customer_coin | currency  }}
                                            </v-chip>
                                            <v-chip v-if="item.current_customer_coin && item.type_id==2 || item.type_id == 8" color="orange" dark>
                                                {{ item.before_customer_coin | currency  }} - {{ item.coin | currency }} = {{ item.current_customer_coin | currency  }}
                                            </v-chip>
                                            <v-chip v-if="item.current_customer_coin && item.type_id==3" color="orange" dark>
                                                {{ item.before_customer_coin | currency  }} - {{ item.coin | currency }} = {{ item.current_customer_coin | currency  }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item.type="{ item }">
                                            <v-chip v-if="item.type_id == 1 || item.type_id == 9" color="teal" dark>
                                                {{item.type}}
                                            </v-chip>
                                            <v-chip v-if="item.type_id==4" color="primary" dark>
                                                {{item.type}}
                                            </v-chip>
                                            <v-chip v-if="item.type_id==2 || item.type_id == 8" color="dark" dark>
                                                {{ item.type}}
                                            </v-chip>
                                            <v-chip v-if="item.type_id==3" color="red" dark>
                                                {{ item.type}}
                                            </v-chip>
                                        </template>
                                    </v-data-table>
                                </div>

                                <div id="fb-post-activity-log-print">
                                    <v-data-table
                                            :headers="headers"
                                            :items="desserts"
                                            :options.sync="options"
                                            :server-items-length="totalDesserts"
                                            :loading="loading"
                                            class="elevation-1"
                                            disable-pagination
                                            hide-default-footer
                                    >
                                        <template v-slot:item.coin="{ item }">
                                            <v-chip v-if="item.type_id == 1 || item.type_id == 9" color="info" dark>
                                                {{ item.money | currency}}
                                            </v-chip>
                                            <v-chip v-else color="info" dark>
                                                {{ item.coin | currency}}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item.status_name="{ item }">
                                            <span>
                                                {{ item.status_name }}
                                           </span>
                                        </template>

                                    </v-data-table>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>
            <v-flex md4 v-if="flag">
                <UserPaymentRight :balanceCurrent="balanceCurrent" :balanceWithdraw="balanceWithdraw" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import UserPaymentRight from "~/components/user-payment/UserPaymentRight";
    // import { COLOR } from "~/config/constant";
    // import {FB_POST_GET_LIST_ORDER, FB_POST_GET_LIST_REACTION, FB_POST_GET_LIST_SEEDING } from "../../store/actions.type";
    import {AUTH_GET_HISTORY_RECHARGE, AUTH_GET_INFO_RECHARGE } from "../../store/actions.type";

    export default {
        components: {
            UserPaymentRight
        },
        data () {
            return {
                search:'',
                totalDesserts: 0,
                desserts: [],
                loading: true,
                options: {},
                headers: [
                    { text: 'Thời Gian', value: 'created_at', align: "center"  },
                    { text: 'Loại', value: 'type', align: "center"  },
                    { text: 'Số tiền', value: 'coin'},
                    { text: 'Số dư', value: 'current_customer_coin', align: "center"  },
                    { text: 'Ghi chú', value: 'job_type'},
                ],
                balanceCurrent: 0,
                balanceWithdraw: 0,
                flag: false,
            }
        },
        created() {

        },
        watch: {
            options: {
                handler () {
                    this.getDataFromApi()
                        .then(data => {
                            this.desserts = data.items
                            this.totalDesserts = data.total
                        })
                },
                deep: true,
            },
        },
        mounted () {
            this.getDataFromApi()
                .then(data => {
                    this.desserts = data.items,
                    this.totalDesserts = data.total
                });
             this.getDataInforFromApi();
        },
        methods: {
            async getDataFromApi () {
                this.loading = true
                const { sortBy, sortDesc, page } = this.options
                let pageNumber = page.page || this.options.page;
                let rowsPerPage = page.itemsPerPage || this.options.itemsPerPage;
                let data =  await this.$store.dispatch(AUTH_GET_HISTORY_RECHARGE, '?page=' + pageNumber + '&rowsPerPage=' + rowsPerPage);
                let items =  data.history_recharge;

                const total = data.total

                if (sortBy.length === 1 && sortDesc.length === 1) {
                    items = items.sort((a, b) => {
                        const sortA = a[sortBy[0]]
                        const sortB = b[sortBy[0]]

                        if (sortDesc[0]) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                    })
                }

                this.loading = false;
                return {items,total};

            },
            async getDataInforFromApi () {
                let data = await this.$store.dispatch(AUTH_GET_INFO_RECHARGE);
                this.balanceCurrent = parseInt(data.coin);
                this.balanceWithdraw = parseInt(data.money_recharged);
                this.flag = true;
            },
            print() {
                this.$htmlToPaper("fb-post-activity-log-print");
            }
        },
    }
</script>
<style lang="scss">
    .div-icon-action{
        i {
            cursor: pointer;
        }
    }
    #fb-post-activity-log-print {
        display: none;
    }
</style>
